/**
 * Button types for the EnDataGridBaseActionButton component.
 */
export const EnButtonType = Object.freeze({
  NONE: null,
  SECONDARY: 'secondary',
  PRIMARY: 'primary',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
});